import { useState } from "react";
import { FiCheck } from "react-icons/fi";

function HotelEquipments({ equipments }) {

  const [showAll, setShowAll] = useState(false);

  const MAX_TOTAL = 12;

  const visibleEquipments = showAll
    ? equipments
    : equipments.slice(0, MAX_TOTAL);

  // 👉 catégories simples
  const categories = {
    "Salle de bain": ["douche", "serviettes", "toilettes", "papier"],
    "Confort": ["climatisation", "insonorisées", "familiales"],
    "Sécurité": ["extincteurs", "caméras", "détecteurs", "alarme", "coffre"],
    "Extérieur": ["mer", "terrasse", "extérieur"],
    "Services": ["réception", "concierge", "bagagerie", "restaurant", "voiture"]
  };

  const getCategory = (item) => {
    const lower = item.toLowerCase();
    for (const [cat, list] of Object.entries(categories)) {
      if (list.some(e => lower.includes(e))) return cat;
    }
    return "Autres";
  };

  // regrouper UNIQUEMENT visible
  const grouped = {};
  visibleEquipments.forEach(item => {
    const cat = getCategory(item);
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(item);
  });

  return (
    <div className="mt-16 px-4 md:px-0" id="equipements">

      {/* SECTION */}
      <div className="
        relative
        rounded-3xl
        backdrop-blur-md

      ">

        {/* HEADER */}
        <div className="mb-8 text-center md:!text-left">
          <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900">
            Équipements
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Tout le nécessaire pour votre séjour
          </p>
        </div>

        {/* CATEGORIES */}
        <div className="max-w-md mx-auto md:max-w-none">
        <div className="flex flex-col gap-8 text-center md:text-left">

          {Object.entries(grouped).map(([category, items], i) => (
            <div key={i}>

              <h3 className="text-lg font-semibold text-gray-900 mb-3 text-center md:text-left">
                {category}
              </h3>

              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">

                {items.map((item, index) => (
                  <div
                    key={index}
                    className="
                      flex items-center justify-center md:justify-start gap-3 text-sm text-gray-700"
                  >

                    {/* ICON CLEAN */}
                    <div className="
                      w-5 h-5 rounded-full
                      bg-[#3A9D23]/10
                      flex items-center justify-center
                      text-[#3A9D23]
                    ">
                      <FiCheck size={12} />
                    </div>

                    {item}

                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>
        </div>

        {/* VOIR PLUS GLOBAL */}
        {equipments.length > MAX_TOTAL && (
          <div className="mt-8 flex justify-center">

  <button
    onClick={() => setShowAll(!showAll)}
    className="
      text-sm font-medium text-gray-700

      px-4 py-2 rounded-lg
      border border-gray-200

      hover:bg-gray-50
      hover:border-gray-300

      transition
    "
  >
    {showAll
      ? "Réduire"
      : `Voir tous les équipements (${equipments.length})`}
  </button>

</div>
        )}

      </div>

    </div>
  );
}

export default HotelEquipments;